<template>
  <div>
    <header class="d-sm-flex justify-content-between align-items-center">
      <h1>Rutas</h1>
      <b-button :to="{name: 'RouteNew'}" variant="outline-primary">Nueva Ruta</b-button>
    </header>

    <hr>

    <template v-if="isAllLoaded">
      <template v-if="isRoutesListEmpty">
        <p class="lead">De momento no hay rutas...</p>
      </template>
      <template v-else>
        <b-table hover :items="routesFormatted" :fields="tableFields" responsive="sm" outlined @row-clicked="rowClicked">
          <template slot="clients" slot-scope="data">
            <h3 class="mb-0"><b-badge variant="info">{{ data.item.name }}</b-badge></h3>
            <p class="text-muted"><small>[{{ data.item.id }}]</small></p>
            <template v-for="(client, idx) in data.item.orderedClients">
              <div :key="idx" class="mb-3">
                <p class="m-0">
                  <b-list-group-item class="bg-light">
                    <b> {{ clients[client[0]].name }} </b>
                  </b-list-group-item>
                </p>
              </div>
            </template>
          </template>
        </b-table>
      </template>
    </template>
    <template v-else>
      <div class="text-center">
        <p class="lead">Loading...</p>
        <b-spinner variant="primary" label="Spinning"></b-spinner>
      </div>
    </template>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { dateMixin } from '@/mixins/dateMixin'

export default {
  name: 'Routes',
  mixins: [dateMixin],
  data () {
    return {
      isRoutesListEmpty: null,
      tableFields: [
        {
          key: 'clients',
          label: 'Nombre Ruta',
          sortable: true
        },
        {
          key: 'date',
          label: 'Fecha',
          sortable: true
        }
      ],
      routes: [],
      clients: {},
      products: {},
      loaded: {
        routes: false,
        clients: false,
        products: false
      }
    }
  },
  computed: {
    routesFormatted () {
      return this.routes.map((r, idx) => {
        // Sacar las claves, crear array y ordenar el array por position
        r.orderedClients = Object.keys(r.clients)
          .map(c => [c, r.clients[c].position])
          .sort((a, b) => a[1] - b[1])
        r.createdAt = this.dateDDMMYYYY(r.createdAt)
        r.date = this.dateDDMMYYYY(r.date)
        return r
      }).reverse()
    },
    isAllLoaded () {
      return this.loaded.routes && this.loaded.clients && this.loaded.products
    }
  },
  created () {
    this.loadRoutes()
    this.loadClients()
    this.loadProducts()
  },
  methods: {
    ...mapActions([
      'getRoutes',
      'getClients',
      'getProducts'
    ]),
    loadRoutes () {
      this.getRoutes()
        .then((res) => {
          this.loaded.routes = true
          if (res.empty) {
            this.isRoutesListEmpty = true
            return false
          }
          res.forEach(doc => {
            this.routes.push({ id: doc.id, ...doc.data() })
          })
        })
        .catch((err) => {
          console.log('[getRoutes]')
          console.log(err)
        })
    },
    loadClients () {
      this.getClients()
        .then((res) => {
          res.forEach(doc => {
            this.clients[doc.id] = { id: doc.id, ...doc.data(), createdAt: this.dateDDMMYYYY(doc.data().createdAt) }
            // this.clients.push({ id: doc.id, ...doc.data() })
          })
          this.loaded.clients = true
        })
        .catch((err) => {
          console.debug('getClients')
          console.log(err)
        })
    },
    loadProducts () {
      this.getProducts()
        .then((res) => {
          res.forEach(doc => {
            this.products[doc.id] = { id: doc.id, ...doc.data(), createdAt: this.dateDDMMYYYY(doc.data().createdAt) }
          })
          this.loaded.products = true
        })
        .catch((err) => {
          console.log(err)
        })
    },
    rowClicked (item, index, ev) {
      this.$router.push({ name: 'RouteDetail', params: { routeId: item.id } })
    }
  }
}
</script>

<style scoped>

</style>
